export default __webpack_public_path__ + "static/media/logo_planalto_capital_rgb_positivo_PNG.5bfca50b.png";